import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { Flower, Menu } from 'lucide-react'
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from '@/components/ui/sheet'

export default function HelpHeader () {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

  return (
    <header className="sticky top-0 z-50 backdrop-blur-md bg-purple-950/80 border-b border-purple-800/50">
      <div className="container mx-auto px-4 py-4">
        <nav className="flex items-center justify-between">
          {/* Logo and Title */}
          <div className="flex items-center gap-2">
            <Flower className="h-6 w-6 text-purple-300" />
            <Link
              to="/help"
              className="text-xl font-bold text-white hover:text-purple-200 transition-colors duration-200"
            >
              Lavender Flow Help
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="flex-1 hidden md:flex items-center ml-8 space-x-6">
            <Link
              to="/"
              className="text-purple-200 hover:text-white transition-colors duration-200 cursor-pointer"
            >
              Home
            </Link>
            <a
              href="https://community.lavenderflow.dev"
              className="text-purple-200 hover:text-white transition-colors duration-200 cursor-pointer"
              target="_blank"
              rel="noopener noreferrer"
            >
              Community
            </a>
            <Link
              to="/integrations"
              className="text-purple-200 hover:text-white transition-colors duration-200 cursor-pointer"
            >
              Integrations
            </Link>
            <Link
              to="/gallery"
              className="text-purple-200 hover:text-white transition-colors duration-200 cursor-pointer"
            >
              Gallery
            </Link>
            <Link
              to="/help/articles?category=api"
              className="text-purple-200 hover:text-white transition-colors duration-200 cursor-pointer"
            >
              API
            </Link>
          </div>

          {/* Mobile Navigation (Hamburger Menu) */}
          <div className="md:hidden flex items-center">
            <Sheet open={isMobileMenuOpen} onOpenChange={setIsMobileMenuOpen}>
              <SheetTrigger asChild>
                <Button variant="ghost" size="icon">
                  <Menu className="h-6 w-6 text-white" />
                  <span className="sr-only">Toggle navigation</span>
                </Button>
              </SheetTrigger>
              <SheetContent side="left" className="bg-purple-900 text-white">
                <SheetHeader>
                  <div className="flex items-center gap-2">
                    <Flower className="h-6 w-6 text-purple-300" />
                    <SheetTitle className="text-white">Lavender Flow Help</SheetTitle>
                  </div>
                </SheetHeader>
                <div className="flex flex-col gap-4 px-4 py-4">
                  <Link
                    to="/"
                    className="text-purple-200 hover:text-white transition-colors duration-200 cursor-pointer"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    Home
                  </Link>
                  <a
                    href="https://community.lavenderflow.dev"
                    className="text-purple-200 hover:text-white transition-colors duration-200 cursor-pointer"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    Community
                  </a>
                  <Link
                    to="/integrations"
                    className="text-purple-200 hover:text-white transition-colors duration-200 cursor-pointer"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    Integrations
                  </Link>
                  <Link
                    to="/gallery"
                    className="text-purple-200 hover:text-white transition-colors duration-200 cursor-pointer"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    Gallery
                  </Link>
                  <Link
                    to="/help/articles?category=api"
                    className="text-purple-200 hover:text-white transition-colors duration-200 cursor-pointer"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    API
                  </Link>
                  <div className="flex flex-col gap-2 mt-4">
                    <Link to="/login" onClick={() => setIsMobileMenuOpen(false)}>
                      <Button variant="ghost" className="w-full text-purple-200 hover:text-white hover:bg-purple-800">
                        Log in
                      </Button>
                    </Link>
                    <Link to="/login" onClick={() => setIsMobileMenuOpen(false)}>
                      <Button className="w-full bg-purple-500 hover:bg-purple-600 text-white">Sign up</Button>
                    </Link>
                  </div>
                </div>
              </SheetContent>
            </Sheet>
          </div>

          {/* Login/Signup Buttons (Desktop) */}
          <div className="hidden md:flex items-center gap-4">
            <Link to="/login">
              <Button variant="ghost" className="text-purple-200 hover:text-white hover:bg-purple-800 transition-all duration-200 cursor-pointer">
                Log in
              </Button>
            </Link>
            <Link to="/login">
              <Button className="bg-purple-500 hover:bg-purple-600 text-white transition-all duration-200 cursor-pointer hover:scale-105">
                Sign up
              </Button>
            </Link>
          </div>
        </nav>
      </div>
    </header>
  )
}
